import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import appointmentAPI from '../../sources/api/appointmentAPI';

// constants
import { APPOINTMENT_CANCEL, APPOINTMENT_UPDATE } from '../../constants/appointmentTypes';
import { APPOINTMENT_CANCELLED_SUCCESS } from '../../constants/messages';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { appointmentSchema } from '../../schemas/Normalizr';
import { push } from 'react-router-redux';
import { toastr } from 'react-redux-toastr';

export function* appointmentCancel(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  if (params.update) {
    try {
      yield *httpSaga(APPOINTMENT_UPDATE, call(appointmentAPI.update, { id: params.id, notes: params.update.notes }), appointmentSchema);
    } catch (e) {
      yield put(error(APPOINTMENT_UPDATE, e));
    } finally {
      yield put(doneIndicator(APPOINTMENT_UPDATE));
    }
  }

  try {
    yield *httpSaga(APPOINTMENT_CANCEL, call(appointmentAPI.cancel, params), appointmentSchema);
    yield toastr.success('Success', APPOINTMENT_CANCELLED_SUCCESS);
  } catch (e) {
    yield put(error(APPOINTMENT_CANCEL, e));
  } finally {
    yield put(doneIndicator(APPOINTMENT_CANCEL));
    if (params.redirectUrl) {
      yield put(push('/reps/calendar'));
    }
  }
}

export function* watchappointmentCancel() {
  yield takeEvery(APPOINTMENT_CANCEL, appointmentCancel);
}

export default function* root() {
  yield all([
    fork(watchappointmentCancel)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/appointment/appointmentCancel.js